import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
  output,
} from '@angular/core';

import { ChatbotLlmOption } from '../../../types/chatbot.model';

@Component({
    selector: 'app-chatbot-header',
    templateUrl: './chatbot-header.component.html',
    styleUrls: ['./chatbot-header.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ChatbotHeaderComponent {
  /**
   * Output events
   */
  protected readonly sidenavToggled = output();

  isCollapsibleChatbotOpen = model<boolean>(true);

  /**
   * Toggles the chatbot visibility state when the button is clicked
   */
  toggleChatDisplay(): void {
    this.isCollapsibleChatbotOpen.update((currentState) => !currentState);
  }
}